import React, { useState, useEffect } from 'react';
import { AccessListItemPerson, AccessScreenHeader } from 'screens/AuditScreens/components';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/react-hooks';
import { AccessFetchError } from '../components/AccessFetchError/AccessFetchError';
import { AuthLoader } from 'screens/LoginScreen';
import { handleFetchMoreError } from 'services';
import { useInView } from 'react-intersection-observer';
import { OutsideOwnershipAccessQuery } from 'services/apollo/auditQueries/auditQueries';
import { FeedListInfinitySpinner } from 'components';

import auditLayoutStyles from './AuditLayout.module.scss';

export const OutsideOwnershipAuditScreen = () => {
  const { t } = useTranslation();
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const { data, fetchMore, error } = useQuery(OutsideOwnershipAccessQuery, {
    variables: { first: 20, cursor: '' },
    fetchPolicy: 'cache-and-network',
  });

  const [ref, inView] = useInView({
    rootMargin: '500px 0px',
    threshold: 0,
  });

  useEffect(() => {
    if (inView === true) {
      triggerFetchMore().then((response) => response);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  const triggerFetchMore = async () => {
    setIsLoadingMore(true);
    const { endCursor } = data.documentSecurityAudit.outsideOwnershipAccess.pageInfo;

    try {
      await fetchMore({
        variables: { first: 20, cursor: endCursor },
        updateQuery: (prevResult: any, { fetchMoreResult }) => {
          fetchMoreResult.documentSecurityAudit.outsideOwnershipAccess.contacts = [
            ...prevResult.documentSecurityAudit.outsideOwnershipAccess.contacts,
            ...fetchMoreResult.documentSecurityAudit.outsideOwnershipAccess.contacts,
          ];
          setIsLoadingMore(false);
          return fetchMoreResult;
        },
      });
    } catch (e) {
      handleFetchMoreError(e);
    }
  };

  if (data === undefined) {
    return <AuthLoader type="DSA" />;
  }

  if (error) {
    return <AccessFetchError />;
  }

  return (
    <div className={auditLayoutStyles.screen}>
      <div className={auditLayoutStyles.header}>
        <AccessScreenHeader
          title={`${data.documentSecurityAudit.outsideOwnershipAccess.pageInfo.total.toLocaleString()} ${t(
            'outsideOwnershipScreen.title'
          )}`}
        />
      </div>
      {data.documentSecurityAudit.outsideOwnershipAccess.contacts.map(
        (person: any, key: number) => (
          <AccessListItemPerson
            key={key}
            person={person}
            buttonMessage={t('outsideOwnershipScreen.list-item-button')}
            showIntegrations={true} 
            type="Full" 
            isOutsideOwner
          />
        )
      )}
      {data.documentSecurityAudit.outsideOwnershipAccess.pageInfo.hasNextPage && (
        <div ref={ref}>
          <FeedListInfinitySpinner isLoadingMore={isLoadingMore} />
        </div>
      )}
    </div>
  );
};
